import { observer } from "mobx-react";
import * as React from "react";
import { IResultadoSummary } from "../../../model";
import { LookupStore } from "../../../stores/LookupStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { sortBy } from "../../../utils";
import { observable } from "mobx";
import { AppStore } from "../../../stores/AppStore";

const numeral = require("numeral");

interface Props {
  onView(classId: number): void;
}

@observer
export class ResultadosSummary extends React.Component<Props, {}> {

  obs = observable({})

  /**
   * Salva no cookie "__DAE-DEI" as informações necessárias
   * (aba selecionada, empresa, período, data inicial e modelo)
   * e abre a página do SPED ou DEI em uma nova aba.
   */
  handleDaeDei(selectedTab: string) {

    localStorage.setItem('__DAE-DEI', JSON.stringify({
      tab: selectedTab,
      empresa: {
        cnpj: AppStore.obs1.selectedEmpresa.cnpj,
        razao_social: AppStore.obs1.selectedEmpresa.razao_social,
        uf: AppStore.obs1.selectedEmpresa.uf,
      },
      periodo: [ResultadoStore.obs.date_start, ResultadoStore.obs.date_end],
      date_start: ResultadoStore.obs.date_start,
      modelo: ResultadoStore.obs.modelo
    }));

    if (selectedTab == "dei") {
      window.open("/dei", "_blank");
    } else {
      window.open("/sped", "_blank");
    }

  }

  render() {
    let totalValorProds = 0;
    let totalFcp = 0;
    let totalIcms = 0;
    let totalIcmsContest = 0;
    let totalAPagar = 0;

    for (let i = 0; i < ResultadoStore.obs.all_summary.length; i++) {
      let item = ResultadoStore.obs.all_summary[i];
      let value = LookupStore.getIcmsClassificacaoDAE(item.icms_classificacao_id);
      item.classificacao = value?.nome || "Sem classificação (itens não calculados)";
      item.dae = value?.dae_avulso || false;
      item.dei = value?.dei || false;
      item.codigo_receita = value?.codigo_receita || "";
    }

    let sorted: IResultadoSummary[] = sortBy(
      ResultadoStore.obs.all_summary,
      "classificacao",
    );

    for (let i = 0; i < sorted.length; i++) {
      let item = sorted[i];
      let aPagar = item.classificacao === "Substituição Tributária" ? 0 : item.valor_icms;
      totalValorProds += item.valor;
      totalFcp += item.valor_fcp;
      totalIcms += item.valor_icms;
      totalIcmsContest += item.valor_contestacao_icms;
      totalAPagar += aPagar - item.valor_contestacao_icms;
    }

    const isPa = AppStore.obs1.selectedEmpresa.uf === "PA";
    const isSimples = AppStore.obs1.selectedEmpresa.simples_nacional;

    return (
      <div className="summary-container" style={{ marginBottom: 100 }}>

        <div className="summary-totals">
          <div className="summary-total-item">
            <span className="summary-total-label">Total Produtos / Receita</span>
            <span className="summary-total-value">{numeral(totalValorProds).format("$ 0,0.00")}</span>
          </div>
          <div className="summary-total-item">
            <span className="summary-total-label">FCP Calculado</span>
            <span className="summary-total-value">{numeral(totalFcp).format("$ 0,0.00")}</span>
          </div>
          <div className="summary-total-item">
            <span className="summary-total-label">ICMS Calculado</span>
            <span className="summary-total-value">{numeral(totalIcms).format("$ 0,0.00")}</span>
          </div>
          <div className="summary-total-item">
            <span className="summary-total-label">Contestado</span>
            <span className="summary-total-value summary-value-warning">{numeral(totalIcmsContest).format("$ 0,0.00")}</span>
          </div>
          <div className="summary-total-item summary-total-highlight">
            <span className="summary-total-label">A Pagar</span>
            <span className="summary-total-value summary-value-primary">{numeral(totalAPagar).format("$ 0,0.00")}</span>
          </div>
        </div>

        <div className="summary-table-wrapper">
          <table className="summary-table">
            <thead>
              <tr>
                <th style={{ width: 50 }}></th>
                <th style={{ textAlign: "left" }}>Classificação</th>
                <th style={{ textAlign: "right" }}>Produtos / Receita</th>
                <th style={{ textAlign: "right" }}>FCP Calc.</th>
                <th style={{ textAlign: "right" }}>ICMS Calc.</th>
                <th style={{ textAlign: "right" }}>Contestado</th>
                <th style={{ textAlign: "right" }}>A Pagar</th>
                <th style={{ textAlign: "right", width: 50 }}>{isSimples ? "DEI" : "DAE"}</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((item: IResultadoSummary) => {
                const icms = item.valor_icms;
                const icmsContest = item.valor_contestacao_icms;
                const aPagar = item.classificacao === "Substituição Tributária" ? 0 : icms;

                return (
                  <tr key={item.icms_classificacao_id}>
                    <td style={{ textAlign: "center" }}>
                      <button
                        className="detalhamento-action-btn"
                        onClick={() => this.props.onView(item.icms_classificacao_id)}
                      >
                        <img src="/images/view.svg" width={20} />
                      </button>
                    </td>
                    <td>{item.classificacao}</td>
                    <td style={{ textAlign: "right" }}>{numeral(item.valor).format("$ 0,0.00")}</td>
                    <td style={{ textAlign: "right" }}>{numeral(item.valor_fcp).format("$ 0,0.00")}</td>
                    <td style={{ textAlign: "right" }}>{numeral(icms).format("$ 0,0.00")}</td>
                    <td style={{ textAlign: "right" }}>{numeral(icmsContest).format("$ 0,0.00")}</td>
                    <td style={{ textAlign: "right", fontWeight: 700, color: "#166470" }}>
                      {numeral(aPagar - icmsContest).format("$ 0,0.00")}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.dae && isPa && !isSimples && (
                        <button className="detalhamento-action-btn" onClick={() => this.handleDaeDei(ResultadoStore.obs.tipo == "Entrada" ? "apuracao_entrada" : "apuracao_saida")}>
                          <img src="/images/share.png" width={18} />
                        </button>
                      )}
                      {item.dei && isPa && isSimples && (
                        <button className="detalhamento-action-btn" onClick={() => this.handleDaeDei("dei")}>
                          <img src="/images/share.png" width={18} />
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
